import React from 'react';
import WorkWithUsContainer from './containers/WorkWithUsContainer';


const WorkWithUsApp = () => <WorkWithUsContainer />;

export default WorkWithUsApp;
